import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Utilities extends Vue {
  get buttonAlignmentClass() {
    return this.isGuidedSignupPage ? 'text-center' : 'text-right';
  }

  get isGuidedSignupPage() {
    return this.$router.currentRoute.name === 'GuidedSignup';
  }
}
